<template>
<v-select :box="!solo" :solo="solo" :hide-details="solo" :single-line="solo" v-model="selectedGateway" :items="macList" :rules="rules" prepend-inner-icon="router" :label="label" :no-data-text="$t('gateway.no_gateway_available')"
  :clearable="clearable">
  <template slot="item" slot-scope="data">
    <v-list-tile-content>
      <v-list-tile-title :class="data.tile.props.value?'primary--text':'black--text'">{{data.item.text}}</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <span class="caption ml-4" :class="data.tile.props.value?'primary--text':'grey--text'">{{data.item.value}}</span>
    </v-list-tile-action>
  </template>
</v-select>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

export default {
  name: 'GatewaySelector',
  mixins: [UserAuth],
  props: {
    value: {
      type: String,
    },
    rules: {
      type: Array
    },
    label: {
      type: String
    },
    solo: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    branch: {
      type: String
    }
  },
  computed: {
    selectedGateway: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    macList() {
      let list = Object.values(this.userMacInfo);

      if (this.branch) {
        list = list.filter(g => g.branch == this.branch);
      }

      return list.map(g => ({
        text: g.hostname || g.mac,
        value: g.mac
      }))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/gateway/GatewaySelector.vue